import axiosInstance from '../axiosInterceptor/axiosInstance'
import selectedOrgId from '../../utils/helpers/selectedOrgId'

// The courts of the selected org.
const getCourts = async (orgId, page = 1, perPage = 40) => {
  const url = `v1/orgs/${selectedOrgId()}/courts?perPage=${perPage}&page=${page}`
  const response = await axiosInstance.get(url)
  return response?.data
}

export default getCourts
